import React, { Component } from "react";
import COLOURS from "util/colours";
import { H4, P } from "visual-components/util/texts";

/**
 * Preview component for Small Image+Text+Button CTA.
 * Displays the CTA in the order: Text → Post Entry Message → Image → Button.
 */
export default class CtaButtonImage extends Component {
  render() {
    const { cta, postEntryMessage } = this.props;

    if (cta.ctaUrl && !cta.ctaUrl.match(/^(?:http(?:s)?\:\/\/)/)) {
      cta.ctaUrl = `http://${cta.ctaUrl}`;
    }

    if (!cta.ctaUrl) {
      return <></>;
    }

    return (
      <div>
        {/* Headline Text */}
        <div className="row text-center">
          <div
            className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
            style={{
              paddingBottom: "15px",
            }}
          >
            <H4>
              <i>{cta.ctaMessageText}</i>
            </H4>
          </div>
        </div>

        {/* Post Entry Message - displayed after headline */}
        {postEntryMessage && (
          <div
            className="row text-center"
            style={{
              paddingBottom: "15px",
            }}
          >
            <P multiline>
              <span dangerouslySetInnerHTML={{ __html: postEntryMessage }} />
            </P>
          </div>
        )}

        {/* Image */}
        {cta.ctaImage && (
          <div className="row text-center">
            <div
              className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
              style={{
                paddingBottom: "15px",
              }}
            >
              <img
                src={cta.ctaImage}
                alt="CTA"
                style={{
                  width: "100%",
                  maxWidth: "300px",
                }}
              />
            </div>
          </div>
        )}

        {/* Button */}
        <div
          className="row"
          style={{
            paddingBottom: "30px",
          }}
        >
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
            <a className="cta-link" href={cta.ctaUrl} target="_blank" rel="noopener noreferrer">
              <button
                type="button"
                className="btn btn-primary"
                style={{
                  borderRadius: "2px",
                  borderWidth: "0px",
                  padding: "10px",
                  fontFamily: "GothamRnd-Book",
                  backgroundColor: COLOURS.inputFocusBorder,
                  color: "#fff",
                }}
              >
                {cta.ctaActionText}
              </button>
            </a>
          </div>
        </div>
      </div>
    );
  }
}
